import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class ExportPriceConversionsProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('export-price-conversions', query)
  }

  getAllActiveItems (query) {
    this.setHeader(getAuthToken())
    return this.get('export-price-conversions/all', query)
  }

  getItemById (id) {
    this.setHeader(getAuthToken())
    return this.get(`export-price-conversions/${id}`)
  }

  createItem (payload) {
    this.setHeader(getAuthToken())
    return this.post('export-price-conversions', payload)
  }

  updateItem (payload) {
    this.setHeader(getAuthToken())
    return this.put(`export-price-conversions/${payload.id}`, payload)
  }

  updateAllItems (payload) {
    this.setHeader(getAuthToken())

    return this.put('export-price-conversions', payload)
  }

  deleteItem (id) {
    this.setHeader(getAuthToken())
    return this.delete(`export-price-conversions/${id}`)
  }
}

export default ExportPriceConversionsProvider
